<template lang="pug">
#app
  top-bar(ref="top-bar", @showModal="showModal")
  router-view(@showModal="showModal")
  page-bottom(@showModal="showModal")
  form-modal(ref="form-modal")
</template>
<script>

export default {
  components: {
  },
  data () {
    return {
      isShow: false
    }
  },
  methods: {
    showModal (isShow) {
      this.isShow = isShow
      this.$refs['form-modal'].boot()
    }
  }
}
</script>
<style lang="stylus">
@import 'reset'
@import 'config'
@import 'lib'
@import 'media-query'

#app
  background-color $bg-color
  min-width $min-width
  overflow hidden

</style>
